
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cpd/oic-non-life/agent",
      function () {
        return require("private-next-pages/cpd/oic-non-life/agent/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cpd/oic-non-life/agent"])
      });
    }
  